interface Props {
  checked: boolean
  onChange: (v: boolean) => void
  disabled?: boolean
  size?: 'sm' | 'md' | 'lg'
  label?: string
}

export function ToggleSwitch({ checked, onChange, disabled, size = 'md', label }: Props) {
  const sizeClass = size === 'md' ? '' : size
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      className={`toggle-switch${sizeClass ? ' ' + sizeClass : ''}`}
      onClick={() => !disabled && onChange(!checked)}
    >
      <span className={`toggle-track${checked ? ' on' : ''}`}>
        <span className={`toggle-thumb${checked ? ' on' : ''}`} />
      </span>
      {label && <span style={{ fontSize: '.85rem', color: 'var(--ink-3)', fontWeight: 500 }}>{label}</span>}
    </button>
  )
}
